/**
 * 
 */
export default {

  /**
   * 
   */
  companyAddress: state => 
    state.companyData ?
    state.companyData.address : '',

  /**
   * 
   */
  companyCommercialBusiness: state => 
    state.companyData ?
    state.companyData.commercial_business : '',

  /**
   * 
   */
  companyName: state => 
    state.companyData ?
    state.companyData.business_name : '',

  /**
   * 
   */
  companyRes: (state, getters) => 
    `Res.${ getters.companyResMonth } de ${ getters.companyResYear } Verifique documento: www.sii.cl`,

  /**
   * 
   */
  companyResMonth: state =>
    state.companyData ?
    state.companyData.sii_resolution_month : '',

  /**
   * 
   */
  companyResYear: state =>
    state.companyData ?
    state.companyData.sii_resolution_year : '',

  /**
   * 
   */
  companyRut: state =>
    state.companyData ?
    state.companyData.rut : '',

  /**
   * 
   */
  customerPaymentOptions: state =>
    state.pchPaymentConditions
      .filter(cond =>
        state.customerCreditOptions.some(opt => opt.days === cond.days)
      )
      .sort((a, b) => a.days - b.days),
}
